export default __webpack_public_path__ + "media/images/fancybox/fancy_nav_left-0e71443c58c5444e0fe9219f30c3b3f4.png";